import { post } from './Tools';

const syncOdoo = async (payload) => {
  const response = await post(`${process.env.REACT_APP_SERVER}odoo_sync/backfill`, payload);
  return response;
};

export { syncOdoo };
